export default "__VITE_PUBLIC_ASSET__e6a114db__"